import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { buttonsV2 as ButtonsV2 } from '@breezeway/brzw-components';

import './empty_content_message.scss';

const { BUTTON } = ButtonsV2.constants.BUTTON_TYPES;

const CLASS_NAME = 'empty-content-message';

class EmptyContentMessage extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    _.invoke(e, 'preventDefault');
    _.invoke(e, 'stopPropagation');

    _.invoke(this.props, 'onClick');
  }

  render() {
    const {
      buttonText,
      className,
      classNameButton,
      classNameIcon,
      classNameImage,
      classNameSubTitle,
      classNameTitle,
      icon,
      iconSize,
      imageSrc,
      subTitle,
      title,
      withoutIcon,
    } = this.props;

    return (
      <div className={classnames(CLASS_NAME, className)}>
        {!withoutIcon && (
          <i
            className={classnames(
              `${CLASS_NAME}__icon`,
              `icon-${icon}`,
              `-${iconSize}`,
              classNameIcon,
            )}
          />
        )}

        {!_.isEmpty(imageSrc) && (
          <img
            alt={title}
            className={classnames(`${CLASS_NAME}__image`, classNameImage)}
            src={imageSrc}
          />
        )}
        {!_.isEmpty(title) && (
          <div className={classnames(`${CLASS_NAME}__title`, classNameTitle)}>{title}</div>
        )}
        {!_.isEmpty(subTitle) && (
          <div className={classnames(`${CLASS_NAME}__sub-title`, classNameSubTitle)}>
            {subTitle}
          </div>
        )}
        {!_.isEmpty(buttonText) && (
          <ButtonsV2.TextButton
            className={classnames(`${CLASS_NAME}__button`, classNameButton)}
            onClick={this.onClick}
            type={BUTTON}
          >
            {buttonText}
          </ButtonsV2.TextButton>
        )}
      </div>
    );
  }
}

EmptyContentMessage.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  classNameButton: PropTypes.string,
  classNameIcon: PropTypes.string,
  classNameImage: PropTypes.string,
  classNameSubTitle: PropTypes.string,
  classNameTitle: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.oneOf(['medium', 'small', 'large']),
  imageSrc: PropTypes.string,
  onClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  subTitle: PropTypes.string,
  title: PropTypes.string,
  withoutIcon: PropTypes.bool,
};

EmptyContentMessage.defaultProps = {
  className: '',
  classNameButton: '',
  classNameIcon: '',
  classNameSubTitle: '',
  classNameTitle: '',
  icon: 'autorobot',
  iconSize: 'medium',
  onClick: () => {},
  withoutIcon: false,
};

export default EmptyContentMessage;
